import Vue from 'vue'
import Router from 'vue-router'
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/

//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/error/401',
    component: () => import('@/views/error/401'),
    hidden: true,
  },
  {
    path: '/error/404',
    component: () => import('@/views/error/404'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    name: 'Index',
    // hidden: true,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: { title: '首页', icon: 'dashboard', affix: true },
        component: () => import('@/views/dashboard/index'),
      },
    ],
  },
  {
    path: '',
    component: Layout,
    name: 'Info',
    hidden: true,
    children: [
      {
        path: '/info',
        component: () => import('@/views/info/index'),
      },
    ],
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
]

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: 'history',
  routes: constantRouterMap,
})

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'AppClient',
    meta: {
      title: '账户管理',
      permissions: ['admin', 'memberQuotaAccountLog', 'memberLedgerLogDetail'],
      icon: 'users',
    },
    children: [
      // {
      //   path: '/app-client/accountLog',
      //   name: 'AppClientAccountLog',
      //   component: () => import('@/views/appClient/accountLog'),
      //   meta: {
      //     title: '账户明细',
      //     permissions: ['admin', 'appClientAccountLog'],
      //   },
      // },
      {
        path: '/member/quotaAccountLog',
        name: 'MemberQuotaAccountLog',
        component: () => import('@/views/member/quotaAccountLog'),
        meta: {
          title: '额度明细',
          permissions: ['admin', 'memberQuotaAccountLog'],
        },
      },
      {
        path: '/member/ledgerLogDetail',
        name: 'MemberLedgerLogDetail',
        component: () => import('@/views/memberOrder/ledgerLogDetail'),
        meta: {
          title: '客户对账',
          permissions: ['admin', 'memberLedgerLogDetail'],
        },
      },
      {
        path: '/member/orderDetail',
        name: 'MemberOrderDetail',
        component: () => import('@/views/memberOrder/orderDetail'),
        meta: {
          title: '订单明细',
          permissions: ['admin', 'memberLedgerLogDetail'],
        },
        hidden: true,
      },
    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'AdministrativeManagement',
    meta: {
      title: '行政管理',
      icon: 'dd',
      permissions: [
        'admin',
        'jobList',
        'departmentList',
        'employeeList',
        'employeeApplyLogs',
      ],
    },
    children: [
      {
        path: '/jobList',
        name: 'JobList',
        component: () => import('@/views/job/index'),
        meta: { title: '职级管理', permissions: ['admin', 'jobList'] },
      },
      {
        path: '/departmentList',
        name: 'DepartmentList',
        component: () => import('@/views/department/index'),
        meta: { title: '部门列表', permissions: ['admin', 'departmentList'] },
      },
      {
        path: '/departmentEmployeeList',
        name: 'DepartmentEmployeeList',
        component: () => import('@/views/department/employeeList'),
        meta: { title: '查看员工', permissions: ['admin', 'departmentList'] },
        hidden: true,
      },
      {
        path: '/employeeList',
        name: 'EmployeeList',
        component: () => import('@/views/employee/index'),
        meta: { title: '员工列表', permissions: ['admin', 'employeeList'] },
      },
      {
        path: '/employeeApplyLogs',
        name: 'EmployeeApplyLogs',
        component: () => import('@/views/employee/applyLog'),
        meta: {
          title: '员工申请列表',
          permissions: ['admin', 'employeeApplyLogs'],
        },
      },
      {
        path: '/employeeApplyLogDetail',
        name: 'EmployeeApplyLogDetail',
        component: () => import('@/views/employee/applyLogDetail'),
        meta: {
          title: '员工申请详情',
          permissions: ['admin', 'employeeApplyLogs'],
        },
        hidden: true,
      },
    ],
  },

  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Order',
    meta: {
      title: '订单管理',
      icon: 'dd',
      permissions: ['admin', 'memberOrderList'],
    },
    children: [
      {
        path: '/member/orderList',
        name: 'MemberOrderList',
        component: () => import('@/views/memberOrder/orderList'),
        meta: { title: '订单列表', permissions: ['admin', 'memberOrderList'] },
      },

    ],
  },
  {
    path: '',
    component: Layout,
    alwaysShow: true,
    name: 'Admin',
    meta: {
      title: '权限管理',
      permissions: ['admin', 'adminList', 'role'],
      icon: 'system',
    },
    children: [
      {
        path: '/roles',
        name: 'Role',
        component: () => import('@/views/role/index'),
        meta: { title: '角色列表', permissions: ['admin', 'role'] },
      },
      {
        path: '/admin/list',
        name: 'Admin',
        component: () => import('@/views/admin/index'),
        meta: { title: '管理员列表', permissions: ['admin', 'adminList'] },
      },
    ],
  },
  { path: '*', redirect: '/error/404', hidden: true },
]
